export default function isBeginElementSupported() {
    if (typeof window !== 'undefined') {
        return document.createElementNS(
            'http://www.w3.org/2000/svg', 'animate',
        ).beginElement;
    }
}
